import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
	getCompanyList,
	getCompanyInfo,
	getOverView,
	getTrendAnalysis,
	getChartAnalysis,
	getAnalysisList,
	getPartnerTrend,
	getTradeRecordList,
} from "@/services";

export const fetchCompanyList = createAsyncThunk("fetchCompanyList", async (payload) => {
	const res = await getCompanyList(payload);
	return res;
});

export const fetchCompanyInfo = createAsyncThunk("fetchCompanyInfo", async (payload) => {
	const res = await getCompanyInfo(payload);
	return res;
});

export const fetchOverView = createAsyncThunk("fetchOverView", async (payload) => {
	const res = await getOverView(payload);
	return res;
});

export const fetchTrendAnalysis = createAsyncThunk("fetchTrendAnalysis", async (payload) => {
	const res = await getTrendAnalysis(payload);
	return res;
});

export const fetchChartAnalysis = createAsyncThunk("fetchChartAnalysis", async (payload) => {
	const res = await getChartAnalysis(payload);
	return res;
});

export const fetchAnalysisList = createAsyncThunk("fetchAnalysisList", async (payload) => {
	const res = await getAnalysisList(payload);
	return res;
});

export const fetchPartnerTrend = createAsyncThunk("fetchPartnerTrend", async (payload) => {
	const res = await getPartnerTrend(payload);
	return res;
});

export const fetchTradeRecordList = createAsyncThunk("fetchTradeRecordList", async (payload) => {
	const res = await getTradeRecordList(payload);
	return res;
});

const CompanySlice = createSlice({
	name: "company",
	initialState: {},
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchCompanyList.rejected, (_, payload) => {
			throw new Error(payload.error.message);
		});
		builder.addCase(fetchCompanyInfo.rejected, (_, payload) => {
			throw new Error(payload.error.message);
		});
		builder.addCase(fetchOverView.rejected, (_, payload) => {
			throw new Error(payload.error.message);
		});
		builder.addCase(fetchTrendAnalysis.rejected, (_, payload) => {
			throw new Error(payload.error.message);
		});
		builder.addCase(fetchChartAnalysis.rejected, (_, payload) => {
			throw new Error(payload.error.message);
		});
		builder.addCase(fetchAnalysisList.rejected, (_, payload) => {
			throw new Error(payload.error.message);
		});
		builder.addCase(fetchPartnerTrend.rejected, (_, payload) => {
			throw new Error(payload.error.message);
		});
		builder.addCase(fetchTradeRecordList.rejected, (_, payload) => {
			throw new Error(payload.error.message);
		});
	},
});

export default CompanySlice.reducer;
